module.exports = __webpack_public_path__ + "static/media/icon-member.245ad952.svg";